import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppRedirectComponent } from './app-redirect.component';
import { PageNotFoundComponent } from './ui';

const routes: Routes = [
  {
    path: '',
    component: AppRedirectComponent
  },
  {
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
  },
  {
    path: 'coach',
    loadChildren: './coach/coach.module#CoachModule',
  },
  {
    path: 'survey',
    loadChildren: './survey/survey.module#SurveyModule',
    data: {
      breadcrumb: 'survey.list'
    }
  },
  {
    path: 'session',
    loadChildren: './session/session.module#SessionModule',
    data: {
      breadcrumb: 'session.list'
    }
  },
  {
    path: 'group',
    loadChildren: './group/group.module#GroupModule',
    data: {
      breadcrumb: 'group.list'
    }
  },
  {
    path: 'reports',
    loadChildren: './reports/reports.module#ReportsModule',
    data: {
      breadcrumb: 'session.report.list'
    }
  },
  {
    path: 'library',
    loadChildren: './library/library.module#LibraryModule',
    data: {
      breadcrumb: 'library'
    }
  },
  {
    path: 'participant',
    loadChildren: './participant/participant.module#ParticipantModule'
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /dist/src/app/app-routing.module.ts